// Read function

export const getRequiredLord = async (nftStakingContract) => {
  return await nftStakingContract.requiredLord();
};

export const getWithdrawalFeesPercentage = async (nftStakingContract) => {
  return await nftStakingContract.withdrawalFeesPercentage();
};

export const getLordBurnPercentage = async (nftStakingContract) => {
  return await nftStakingContract.lordBurnPercentage();
};

export const getStakers = async (nftStakingContract, userAddress) => {
  return await nftStakingContract.stakers(userAddress);
};

export const getStakedTokens = async (nftStakingContract, userAddress) => {
  return await nftStakingContract.getActiveStakedNFTs(userAddress);
};

export const getMetaspaceBaseApiURL = async (nftStakingContract) => {
  return await nftStakingContract.metaspaceBaseApiURL();
};

export const decodeData = async (nftStakingContract, data) => {
  return await nftStakingContract.decodeData(data);
};

export const isApprovedForAll = async (
  nftContract,
  userAddress,
  nftStakingaddress
) => {
  return await nftContract.isApprovedForAll(userAddress, nftStakingaddress);
};

export const getTokenOfOwnerByIndex = async (
  nftContract,
  userAddress,
  index
) => {
  try{
    
  return await nftContract.tokenOfOwnerByIndex(userAddress, index);
  }catch(err){
    console.error("Error in getTokenOfOwnerByIndex:", err);
    return null;
  }
};

export const nftApprove = async (nftContract, nftStakingaddress,provider) => {
  try{
     let maxFeePerGas = (await provider.getFeeData()).maxFeePerGas;
    let maxPriorityFeePerGas = (await provider.getFeeData()).maxPriorityFeePerGas;
  const tx = await nftContract.setApprovalForAll(nftStakingaddress, true, {
      maxFeePerGas: maxFeePerGas + BigInt(5000000000),
      maxPriorityFeePerGas: maxPriorityFeePerGas + BigInt(4000000000),
    });
  const receipt = await tx.wait(1);
  return receipt;
  }catch(err){
    console.log(err)
    return null;
  }
};

// Write function

export const setStake = async (nftStakingContract, nftAddress, tokenID, provider) => {
  try{
    let maxFeePerGas= (await provider.getFeeData()).maxFeePerGas;
    let maxPriorityFeePerGas= (await provider.getFeeData()).maxPriorityFeePerGas;
    const tx = await nftStakingContract.stake(nftAddress, tokenID,{
      maxFeePerGas: maxFeePerGas + BigInt(5000000000),
      maxPriorityFeePerGas: maxPriorityFeePerGas + BigInt(4000000000),
    });
  const rec = await tx.wait();
  return rec;
  }catch(err){
    console.log(err)
    return null;
  }
};

export const setWithdraw = async (nftStakingContract, nftAddress, tokenID) => {
  // console.log(nftStakingContract, nftAddress, tokenID, "nftinfo");
  const tx = await nftStakingContract.withdraw(nftAddress, tokenID);
  const rec = await tx.wait();
  return rec;
};

export const setClaimRewards = async (nftStakingContract) => {
  const tx = await nftStakingContract.claimRewards();
  const rec = await tx.wait();
  return rec;
};
